// import React, { useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import bedroom1video from '../Assets/slider/bedroom1video.mp4';
// import baseinvideo from '../Assets/slider/Basinvideo.mp4';
// import shoesrackvideo from '../Assets/slider/Entrancevideo.mp4';
// import kitchen from '../Assets/slider/Kitchenvideo.mp4';

// const VideoShowcase = () => {
//     const [activeVideoId, setActiveVideoId] = useState(1);
//     const [activeFullscreenVideo, setActiveFullscreenVideo] = useState(null);
//     const videoRefs = useRef({});
//     const scrollerRef = useRef(null);

//     // 8 Premium Video Case Studies Dataset
//     const videoPlaylist = [
//         { id: 1, num: '01', title: 'The Linen Kitchen Vault', category: 'Kitchen Architecture', duration: '0:15', src: kitchen, desc: 'Bespoke modular framework engineering with warm overhead pastel luminance profiles and hidden channel integration paths.', sqft: '450 SQFT' },
//         { id: 2, num: '02', title: 'Alabaster Bedroom Suite', category: 'Luxury Residential', duration: '0:14', src: bedroom1video, desc: 'Symmetrical space planning intended to optimize rest parameters, using organic linen layers and recessed wall downlights.', sqft: '680 SQFT' },
//         { id: 3, num: '03', title: 'Travertine Wash Counter', category: 'Bespoke Item Art', duration: '0:12', src: baseinvideo, desc: 'Premium custom natural stone installations highlighting raw grain texture paths with fully integrated brass hardware fixtures.', sqft: 'Custom Vanity' },
//         { id: 4, num: '04', title: 'The Entrance Portal', category: 'Foyer Layout', duration: '0:18', src: shoesrackvideo, desc: 'Clean geometric lines hiding smart functional utility parameters within elegant floor-to-ceiling wooden panel partitions.', sqft: '180 SQFT' },
//         { id: 5, num: '05', title: 'Scandinavian Culinary Studio', category: 'Kitchen Architecture', duration: '0:15', src: kitchen, desc: 'Minimalist white-oak accents embedded inside a premium quartz custom waterfall island layout built for gourmet staging.', sqft: '520 SQFT' },
//         { id: 6, num: '06', title: 'Minimalist Wardrobe Vault', category: 'Luxury Residential', duration: '0:14', src: bedroom1video, desc: 'Integrated ambient floor uplighting systems accentuating floor-to-ceiling customized smoky matte glass wardrobe storage surfaces.', sqft: '340 SQFT' },
//         { id: 7, num: '07', title: 'Floating Foyer Console Deck', category: 'Foyer Layout', duration: '0:18', src: shoesrackvideo, desc: 'Soft backlit vertical panel transitions generating a warm, high-end welcoming experience upon stepping past the threshold.', sqft: '210 SQFT' },
//         { id: 8, num: '08', title: 'Marble Basin Vanity Unit', category: 'Bespoke Item Art', duration: '0:12', src: baseinvideo, desc: 'Sleek wall-hung modern parameters minimizing floor footprints while maximizing functional spatial volumes inside minimal rooms.', sqft: 'Custom Build' }
//     ];

//     const currentProject = videoPlaylist.find(v => v.id === activeVideoId) || videoPlaylist;

//     const theme = {
//         background: '#F8F6F2',   
//         surface: '#FFFFFF',      
//         accent: '#D4AF37',       
//         textMain: '#2C302E',     
//         textMuted: '#7A827E',    
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     // Tracks horizontal scrolling position to auto-activate cards on swipe or scroll bounds
//     const handleScrollPhysics = () => {
//         if (!scrollerRef.current) return;
//         const scroller = scrollerRef.current;
//         const cardElement = scroller.firstChild;
//         if (!cardElement) return;

//         const cardWidth = cardElement.offsetWidth + 25; // width + gap
//         const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 3);
//         const index = Math.floor(scrollPosition / cardWidth);

//         if (videoPlaylist[index] && videoPlaylist[index].id !== activeVideoId) {
//             if (videoRefs.current[activeVideoId]) videoRefs.current[activeVideoId].pause();
//             setActiveVideoId(videoPlaylist[index].id);
//             if (videoRefs.current[videoPlaylist[index].id]) {
//                 videoRefs.current[videoPlaylist[index].id].play().catch(() => {});
//             }
//         }
//     };

//     const handleMouseEnter = (id) => {
//         setActiveVideoId(id);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].play().catch(() => { });
//         }
//     };

//     const handleMouseLeave = (id) => {
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].pause();
//             videoRefs.current[id].currentTime = 0;
//         }
//     };

//     const inlineCinemaStyles = `
//     @keyframes lineExtend { from { width: 0%; } to { width: 100%; } }
//     .animate-gold-line { animation: lineExtend 0.5s ease forwards; }

//     @keyframes textReveal { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
//     .animate-text-reveal { animation: textReveal 0.4s ease-out forwards; }

//     /* Custom horizontal scroll bar styling */
//     .custom-scroll-deck::-webkit-scrollbar {
//         height: 4px;
//     }
//     .custom-scroll-deck::-webkit-scrollbar-track {
//         background: rgba(44, 48, 46, 0.03);
//     }
//     .custom-scroll-deck::-webkit-scrollbar-thumb {
//         background: rgba(214, 175, 55, 0.3);
//         border-radius: 10px;
//     }

//     /* Responsive modifications for smaller mobile setups */
//     @media (max-width: 991px) {
//         .cinema-asymmetric-split { flex-direction: column-reverse !important; gap: 30px !important; }
//         .cinema-left-sticky-deck { position: relative !important; top: 0 !important; height: auto !important; min-width: 100% !important; padding-right: 0 !important; border-right: none !important; }
//         .cinema-film-strip-card { min-width: 80vw !important; height: 360px !important; }
//         .showcase-screen-wrapper { padding: 30px 20px !important; }
//         .cinema-main-header { font-size: 2.2rem !important; }
//     }
//   `;

//     return (
//         <div className="showcase-screen-wrapper" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             overflowX: 'hidden'
//         }}>
//             <style>{inlineCinemaStyles}</style>

//             {/* Return Navigation Anchor */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <Link to="/" style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px', fontWeight: '500' }}>
//                     ← Back to Main Screen
//                 </Link>
//                 <span style={{ fontSize: '0.75rem', color: theme.textMuted, letterSpacing: '3px', textTransform: 'uppercase', fontWeight: '600' }}>
//                     Kinetic Design Reels
//                 </span>
//             </div>

//             {/* ==================== CORE TWO-COLUMN SIDE-BY-SIDE PLATFORM ==================== */}
//             <div className="cinema-asymmetric-split" style={{ display: 'flex', gap: '60px', marginTop: '20px', alignItems: 'stretch' }}>

//                 {/* ==================== LEFT AREA: METADATA DESCRIPTION CARDS ==================== */}
//                 <div className="cinema-left-sticky-deck" style={{
//                     flex: '0.8',
//                     minWidth: '320px',
//                     position: 'sticky',
//                     top: '40px',
//                     height: 'calc(100vh - 120px)',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     paddingRight: '40px',
//                     borderRight: `1px solid ${theme.border}`,
//                     boxSizing: 'border-box'
//                 }}>
//                     <div>
//                         <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Motion Architecture</span>
//                         <h1 className="cinema-main-header" style={{ fontSize: '2.8rem', fontWeight: '300', margin: '5px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1' }}>Cinematic Reels</h1>

//                         {/* Interactive dynamic narration reveal container block */}
//                         <div key={activeVideoId} className="animate-text-reveal" style={{ marginTop: '20px' }}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '15px', color: theme.accent, fontWeight: '700', fontSize: '0.9rem', fontFamily: 'monospace' }}>
//                                 <span>{currentProject.num}</span>
//                                 <div style={{ height: '1px', background: theme.accent, width: '30px' }} />
//                                 <span style={{ textTransform: 'uppercase', letterSpacing: '1.5px' }}>{currentProject.category}</span>
//                             </div>

//                             <h2 style={{ fontSize: '2rem', fontWeight: '400', margin: '15px 0', color: theme.textMain, letterSpacing: '0.5px' }}>{currentProject.title}</h2>
//                             <p style={{ fontSize: '1rem', lineHeight: '1.7', color: theme.textMuted, maxWidth: '440px', margin: '0 0 30px 0' }}>{currentProject.desc}</p>
//                         </div>
//                     </div>

//                     <div key={`metrics-${activeVideoId}`} className="animate-text-reveal" style={{ paddingBottom: '20px' }}>
//                         <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '15px', width: 'fit-content' }}>
//                             <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: theme.textMuted, letterSpacing: '1px', display: 'block' }}>Project Dimensions</span>
//                             <span style={{ fontSize: '1.3rem', fontWeight: '600', color: theme.textMain, marginTop: '4px', display: 'block' }}>{currentProject.sqft}</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ==================== RIGHT AREA: UNIFIED HORIZONTAL FILM REEL STRIP ==================== */}
//                 <div 
//                     className="custom-scroll-deck" 
//                     ref={scrollerRef}
//                     onScroll={handleScrollPhysics} 
//                     style={{ 
//                         flex: '1.6', 
//                         display: 'flex', 
//                         flexDirection: 'row',       // Forces Left-to-Right orientation on Desktop + Mobile
//                         overflowX: 'auto',          // Enables native horizontal touch/mouse scrolling
//                         overflowY: 'hidden',
//                         gap: '25px',
//                         padding: '10px 5px 25px 5px',
//                         scrollSnapType: 'x mandatory',
//                         alignItems: 'center'
//                     }}
//                 >
//                     {videoPlaylist.map((video) => {
//                         const isActive = activeVideoId === video.id;

//                         return (
//                             <div
//                                 key={video.id}
//                                 className="cinema-film-strip-card"
//                                 onMouseEnter={() => handleMouseEnter(video.id)}
//                                 onMouseLeave={() => handleMouseLeave(video.id)}
//                                 onClick={() => setActiveFullscreenVideo(video.src)}
//                                 style={{
//                                     position: 'relative',
//                                     height: '460px',
//                                     minWidth: '400px',       // Clean cinematic proportion width across desktop monitors
//                                     borderRadius: '24px',
//                                     overflow: 'hidden',
//                                     background: '#1A1C1B',
//                                     border: `1px solid ${isActive ? theme.accent : theme.border}`,
//                                     cursor: 'pointer',
//                                     boxShadow: isActive ? '0 20px 45px rgba(212, 175, 55, 0.08)' : '0 4px 20px rgba(0,0,0,0.01)',
//                                     transform: isActive ? 'translateY(-6px)' : 'translateY(0)',
//                                     transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
//                                     scrollSnapAlign: 'center',
//                                     flexShrink: 0
//                                 }}
//                             >
//                                 <video
//                                     ref={(el) => (videoRefs.current[video.id] = el)}
//                                     loop
//                                     muted
//                                     playsInline
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isActive ? 1 : 0.55,
//                                         filter: isActive ? 'none' : 'grayscale(20%) brightness(85%)',
//                                         transition: 'all 0.5s ease'
//                                     }}
//                                 >
//                                     <source src={video.src} type="video/mp4" />
//                                 </video>

//                                 <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 100%)', zIndex: 2, pointerEvents: 'none' }} />

//                                 {isActive && (
//                                     <div className="animate-gold-line" style={{ position: 'absolute', bottom: 0, left: 0, height: '4px', background: theme.accent, zIndex: 4 }} />
//                                 )}

//                                 <div style={{ position: 'absolute', bottom: '25px', left: '25px', zIndex: 3, color: '#FFF' }}>
//                                     <span style={{ fontSize: '0.8rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}>{video.category}</span>
//                                     <h4 style={{ margin: '4px 0 0 0', fontWeight: '400', fontSize: '1.1rem', letterSpacing: '0.5px' }}>{video.title}</h4>
//                                 </div>

//                                 <div style={{ position: 'absolute', bottom: '25px', right: '25px', zIndex: 3, background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(6px)', color: '#FFF', padding: '5px 12px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '600' }}>
//                                     {video.duration} <span style={{ marginLeft: '6px', color: theme.accent }}>▶</span>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//             </div>

//             {/* ==================== IMMERSIVE THEATER OVERLAY LIGHTBOX POPUP ==================== */}
//             {activeFullscreenVideo && (
//                 <div 
//                     onClick={() => setActiveFullscreenVideo(null)}
//                     style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(15, 17, 21, 0.98)', zIndex: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(15px)' }}
//                 >
//                     <button onClick={() => setActiveFullscreenVideo(null)} style={{ position: 'absolute', top: '30px', right: '40px', background: 'none', border: 'none', color: '#FFF', fontSize: '2.5rem', cursor: 'pointer', opacity: 0.8 }}>✕</button>
//                     <video autoPlay controls playsInline onClick={(e) => e.stopPropagation()} style={{ width: '90vw', maxHeight: '85vh', borderRadius: '16px', boxShadow: '0 30px 70px rgba(0,0,0,0.8)', background: '#000' }}>
//                         <source src={activeFullscreenVideo} type="video/mp4" />
//                     </video>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default VideoShowcase;


// import React, { useState, useRef, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import bedroom1video from '../Assets/slider/bedroom1video.mp4';
// import baseinvideo from '../Assets/slider/Basinvideo.mp4';
// import shoesrackvideo from '../Assets/slider/Entrancevideo.mp4';
// import kitchen from '../Assets/slider/Kitchenvideo.mp4';
// import kitchennew from '../Assets/slider/Kitchenvideonew.mp4';

// import lrvideo1 from '../Assets/slider/sanketsirLivingroomvideo.mp4';
// import lrvideo2 from '../Assets/slider/livingroomvideo.mp4';

// import baseroomvideo2 from '../Assets/slider/Bedroomvideo.mp4';

// const VideoShowcase = () => {
//     const [activeVideoId, setActiveVideoId] = useState(1);
//     const [activeFullscreenVideo, setActiveFullscreenVideo] = useState(null);
//     const videoRefs = useRef({});
//     const scrollerRef = useRef(null);

//     // Dynamic Tracking Reference Hooks for Speed Dampening Logic
//     const targetScrollLeft = useRef(0);
//     const currentScrollLeft = useRef(0);
//     const animationFrameId = useRef(null);

//     // 8 Premium Video Case Studies Dataset
//     const videoPlaylist = [
//         { id: 1, num: '01', title: 'The Linen Kitchen Vault', category: 'Kitchen Architecture', duration: '0:31', src: kitchen, desc: 'Bespoke modular framework engineering with warm overhead pastel luminance profiles and hidden channel integration paths.', sqft: '450 SQFT' },
//         { id: 2, num: '02', title: 'Alabaster Bedroom Suite', category: 'Luxury Residential', duration: '0:49', src: bedroom1video, desc: 'Symmetrical space planning intended to optimize rest parameters, using organic linen layers and recessed wall downlights.', sqft: '680 SQFT' },
//         { id: 3, num: '03', title: 'Sleek Modern Washbasin Vanity', category: 'Bespoke Washbasin Alcove', duration: '0:8', src: baseinvideo, desc: 'This bespoke washbasin alcove pairs rich wooden cabinetry with a bold black vessel sink. Framed by fluted wall tiles and illuminated by sculptural ribbon sconces, the tailored layout creates a striking, luxurious focal point.', sqft: 'Custom Vanity' },
//         { id: 4, num: '04', title: 'Elegant Foyer Entryway Layout', category: 'Foyer Layout', duration: '0:20', src: shoesrackvideo, desc: 'A warm and sophisticated residential entry featuring a custom wooden shoe rack with patterned arch inserts and an integrated planter cutout. Above, a textured, backlit circular nameplate shelf adds a personalized artistic statement to the welcoming space.', sqft: '1200 SQFT' },
//         { id: 5, num: '05', title: 'Japandi Living Room Layout', category: 'Luxury Residential', duration: '0:57', src: lrvideo1, desc: 'This serene residential living room blends Japandi design with functional luxury, featuring mid-century inspired wooden furniture with cane detailing. A large backlit circular botanical artwork anchors the fluted wall panelling, creating a calm and inviting atmosphere', sqft: '520 SQFT' },
//         { id: 6, num: '06', title: 'Bespoke Platform Bedroom Design', category: 'Bespoke Item Art', duration: '0:51', src: baseroomvideo2, desc: 'A sophisticated primary bedroom maximizing space with an elevated wooden platform bed and integrated floor-to-ceiling arched wardrobes. The textured dark stone accent wall, accented by hidden warm LED strip lighting and a plush channel-tufted headboard, creates an intimate and luxurious sanctuary.', sqft: '340 SQFT' },
//         { id: 7, num: '07', title: 'Traditional Wooden Seating Lounge', category: 'Luxury Residential', duration: '0:42', src: lrvideo2, desc: 'A refined formal living setup featuring finely carved solid wood sofa sets paired with traditional Indian block-printed upholstery. Anchored by an intricate patterned area rug and flanked by sheer floor-to-ceiling curtains, this space blends classic heritage charm with modern layout fluidity.', sqft: '210 SQFT' },
//         { id: 8, num: '08', title: 'Contemporary Modular Kitchen Design', category: 'Kitchen Architecture', duration: '0:38', src: kitchennew, desc: 'A bright, space-efficient L-shaped kitchen featuring sleek handleless high-gloss white cabinetry paired with durable black granite countertops. A striking blue and white Moroccan-patterned tile backsplash serves as a vibrant visual anchor, beautifully illuminated by integrated under-cabinet LED profile lighting.', sqft: '200 SQFT', }
//     ];

//     const currentProject = videoPlaylist.find(v => v.id === activeVideoId) || videoPlaylist[0];

//     const theme = {
//         background: '#F8F6F2',
//         surface: '#FFFFFF',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     // ==================== LERP MATH RENDERING ENGINE ====================
//     useEffect(() => {
//         const smoothRenderLoop = () => {
//             if (!scrollerRef.current) return;

//             // 0.04 is your Speed Control. Lower = Slower/Smoother, Higher = Snappier
//             const speedFactor = 0.04;

//             // Linear Interpolation: distance remaining * speed factor
//             const distance = targetScrollLeft.current - currentScrollLeft.current;
//             currentScrollLeft.current += distance * speedFactor;

//             // Push pixel offset update directly to the DOM
//             scrollerRef.current.scrollLeft = currentScrollLeft.current;

//             // Loop animation continuously via window rendering tick pipelines
//             animationFrameId.current = requestAnimationFrame(smoothRenderLoop);
//         };

//         animationFrameId.current = requestAnimationFrame(smoothRenderLoop);

//         return () => {
//             if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
//         };
//     }, []);

//     useEffect(() => {
//         document.body.style.overflow =
//             activeFullscreenVideo ? 'hidden' : 'auto';

//         return () => {
//             document.body.style.overflow = 'auto';
//         };
//     }, [activeFullscreenVideo]);
//     // ==================== CONTROLLED MOUSE COORDINATE MAPPING ====================
//     const handleCursorTracking = (e) => {
//         if (!scrollerRef.current || window.innerWidth <= 991) return;
//         const scroller = scrollerRef.current;
//         const rect = scroller.getBoundingClientRect();

//         // Find cursor coordinate relative to container width
//         const mouseX = e.clientX - rect.left;

//         // Create buffer dead-zones at the edges (10% left/right padding) to prevent violent snapping
//         let positionRatio = (mouseX - rect.width * 0.1) / (rect.width * 0.8);
//         if (positionRatio < 0) positionRatio = 0;
//         if (positionRatio > 1) positionRatio = 1;

//         const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

//         // Update the target vector reference hook instead of forcefully snapping the element
//         targetScrollLeft.current = positionRatio * maxScrollLeft;
//     };

//     const handleScrollPhysics = () => {
//         if (!scrollerRef.current) return;
//         const scroller = scrollerRef.current;
//         const cardElement = scroller.firstChild;
//         if (!cardElement) return;

//         const cardWidth = cardElement.offsetWidth + 25;
//         const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 3);
//         const index = Math.floor(scrollPosition / cardWidth);

//         if (videoPlaylist[index] && videoPlaylist[index].id !== activeVideoId) {
//             if (videoRefs.current[activeVideoId]) videoRefs.current[activeVideoId].pause();
//             setActiveVideoId(videoPlaylist[index].id);
//             if (videoRefs.current[videoPlaylist[index].id]) {
//                 videoRefs.current[videoPlaylist[index].id].play().catch(() => { });
//             }
//         }
//     };

//     const handleMouseEnter = (id) => {
//         setActiveVideoId(id);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].play().catch(() => { });
//         }
//     };

//     const handleMouseLeave = (id) => {
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].pause();
//             videoRefs.current[id].currentTime = 0;
//         }
//     };



//     const inlineCinemaStyles = `
//     @keyframes lineExtend { from { width: 0%; } to { width: 100%; } }
//     .animate-gold-line { animation: lineExtend 0.5s ease forwards; }

//     @keyframes textReveal { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
//     .animate-text-reveal { animation: textReveal 0.4s ease-out forwards; }

//     .custom-scroll-deck::-webkit-scrollbar { display: none; }
//     .custom-scroll-deck { -ms-overflow-style: none; scrollbar-width: none; }

//     @media (max-width: 991px) {
//         .cinema-asymmetric-split { flex-direction: column-reverse !important; gap: 30px !important; }
//         .cinema-left-sticky-deck { position: relative !important; top: 0 !important; height: auto !important; min-width: 100% !important; padding-right: 0 !important; border-right: none !important; }
//         .cinema-film-strip-card { min-width: 80vw !important; height: 360px !important; }
//         .showcase-screen-wrapper { padding: 30px 20px !important; }
//         .cinema-main-header { font-size: 2.2rem !important; }
//     }
//         @keyframes fadeIn {
//     from {
//         opacity: 0;
//     }
//     to {
//         opacity: 1;
//     }
// }

// @keyframes scaleIn {
//     from {
//         opacity: 0;
//         transform: scale(.94);
//     }
//     to {
//         opacity: 1;
//         transform: scale(1);
//     }
// }
//   `;

//     return (
//         <div className="showcase-screen-wrapper" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             overflowX: 'hidden'
//         }}>
//             <style>{inlineCinemaStyles}</style>

//             {/* Return Link */}


//             {/* ==================== CORE ASYMMETRIC CONTROLLER DECK ==================== */}
//             <div className="cinema-asymmetric-split" style={{ display: 'flex', gap: '60px', marginTop: '20px', alignItems: 'stretch' }}>

//                 {/* LEFT AREA: METADATA DESCRIPTION */}
//                 <div className="cinema-left-sticky-deck" style={{
//                     flex: '0.8',
//                     minWidth: '320px',
//                     position: 'sticky',
//                     top: '40px',
//                     height: 'calc(100vh - 120px)',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     paddingRight: '40px',
//                     borderRight: `1px solid ${theme.border}`,
//                     boxSizing: 'border-box'
//                 }}>
//                     <div>
//                         <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Motion Architecture</span>
//                         <h1 className="cinema-main-header" style={{ fontSize: '2.8rem', fontWeight: '300', margin: '5px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1' }}>Cinematic Reels</h1>

//                         <div key={activeVideoId} className="animate-text-reveal" style={{ marginTop: '20px' }}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '15px', color: theme.accent, fontWeight: '700', fontSize: '0.9rem', fontFamily: 'monospace' }}>
//                                 <span>{currentProject.num}</span>
//                                 <div style={{ height: '1px', background: theme.accent, width: '30px' }} />
//                                 <span style={{ textTransform: 'uppercase', letterSpacing: '1.5px' }}>{currentProject.category}</span>
//                             </div>

//                             <h2 style={{ fontSize: '2rem', fontWeight: '400', margin: '15px 0', color: theme.textMain, letterSpacing: '0.5px' }}>{currentProject.title}</h2>
//                             <p style={{ fontSize: '1rem', lineHeight: '1.7', color: theme.textMuted, maxWidth: '440px', margin: '0 0 30px 0' }}>{currentProject.desc}</p>
//                         </div>
//                     </div>

//                     <div key={`metrics-${activeVideoId}`} className="animate-text-reveal" style={{ paddingBottom: '20px' }}>
//                         <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '15px', width: 'fit-content' }}>
//                             <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: theme.textMuted, letterSpacing: '1px', display: 'block' }}>Project Dimensions</span>
//                             <span style={{ fontSize: '1.3rem', fontWeight: '600', color: theme.textMain, marginTop: '4px', display: 'block' }}>{currentProject.sqft}</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* RIGHT AREA: SMOOTH DAMPENED FILM REEL DECK */}
//                 <div
//                     className="custom-scroll-deck"
//                     ref={scrollerRef}
//                     onMouseMove={handleCursorTracking}
//                     onScroll={handleScrollPhysics}
//                     style={{
//                         flex: '1.6',
//                         display: 'flex',
//                         flexDirection: 'row',
//                         overflowX: 'auto',
//                         overflowY: 'hidden',
//                         gap: '25px',
//                         padding: '10px 5px 25px 5px',
//                         alignItems: 'center'
//                     }}
//                 >
//                     {videoPlaylist.map((video) => {
//                         const isActive = activeVideoId === video.id;

//                         return (
//                             <div
//                                 key={video.id}
//                                 className="cinema-film-strip-card"
//                                 onMouseEnter={() => handleMouseEnter(video.id)}
//                                 onMouseLeave={() => handleMouseLeave(video.id)}
//                                 onClick={() => setActiveFullscreenVideo(video.src)}
//                                 style={{
//                                     position: 'relative',
//                                     height: '460px',
//                                     minWidth: '400px',
//                                     borderRadius: '24px',
//                                     overflow: 'hidden',
//                                     background: '#1A1C1B',
//                                     border: `1px solid ${isActive ? theme.accent : theme.border}`,
//                                     cursor: 'pointer',
//                                     boxShadow: isActive ? '0 20px 45px rgba(212, 175, 55, 0.08)' : '0 4px 20px rgba(0,0,0,0.01)',
//                                     transform: isActive ? 'translateY(-6px)' : 'translateY(0)',
//                                     transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
//                                     scrollSnapAlign: 'center',
//                                     flexShrink: 0
//                                 }}
//                             >
//                                 <video
//                                     ref={(el) => (videoRefs.current[video.id] = el)}
//                                     loop
//                                     muted
//                                     playsInline
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         opacity: isActive ? 1 : 0.55,
//                                         filter: isActive ? 'none' : 'grayscale(20%) brightness(85%)',
//                                         transition: 'all 0.5s ease'
//                                     }}
//                                 >
//                                     <source src={video.src} type="video/mp4" />
//                                 </video>

//                                 <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 100%)', zIndex: 2, pointerEvents: 'none' }} />

//                                 {isActive && (
//                                     <div className="animate-gold-line" style={{ position: 'absolute', bottom: 0, left: 0, height: '4px', background: theme.accent, zIndex: 4 }} />
//                                 )}

//                                 <div style={{ position: 'absolute', bottom: '25px', left: '25px', zIndex: 3, color: '#FFF' }}>
//                                     <span style={{ fontSize: '0.8rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}>{video.category}</span>
//                                     <h4 style={{ margin: '4px 0 0 0', fontWeight: '400', fontSize: '1.1rem', letterSpacing: '0.5px' }}>{video.title}</h4>
//                                 </div>

//                                 <div style={{ position: 'absolute', bottom: '25px', right: '25px', zIndex: 3, background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(6px)', color: '#FFF', padding: '5px 12px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '600' }}>
//                                     {video.duration} <span style={{ marginLeft: '6px', color: theme.accent }}>▶</span>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//             </div>

//             {/* Lightbox Modal */}
//             {/* {activeFullscreenVideo && (
//                 <div
//                     onClick={() => setActiveFullscreenVideo(null)}
//                     style={{
//                         position: 'fixed',
//                         inset: 0,
//                         background: 'rgba(0,0,0,0.96)',
//                         backdropFilter: 'blur(20px)',
//                         zIndex: 9999,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         animation: 'fadeIn 0.4s ease'
//                     }}
//                 >

//                     <button
//                         onClick={() => setActiveFullscreenVideo(null)}
//                         style={{
//                             position: 'absolute',
//                             top: '30px',
//                             right: '35px',
//                             width: '55px',
//                             height: '55px',
//                             borderRadius: '50%',
//                             border: '1px solid rgba(255,255,255,0.15)',
//                             background: 'rgba(255,255,255,0.08)',
//                             color: '#fff',
//                             fontSize: '1.8rem',
//                             cursor: 'pointer',
//                             backdropFilter: 'blur(10px)',
//                             transition: 'all .3s ease'
//                         }}
//                     >
//                         ✕
//                     </button>


//                     <div
//                         onClick={(e) => e.stopPropagation()}
//                         style={{
//                             width: '92vw',
//                             maxWidth: '1500px',
//                             position: 'relative',
//                             borderRadius: '24px',
//                             overflow: 'hidden',
//                             boxShadow:
//                                 '0 40px 120px rgba(0,0,0,0.8)',
//                             transform: 'translateY(0)',
//                             animation: 'scaleIn 0.4s ease'
//                         }}
//                     >
//                         <video
//                             autoPlay
//                             controls
//                             playsInline
//                             controlsList="nodownload"
//                             style={{
//                                 width: '100%',
//                                 maxHeight: '88vh',
//                                 display: 'block',
//                                 objectFit: 'contain',
//                                 background: '#000'
//                             }}
//                         >
//                             <source
//                                 src={activeFullscreenVideo}
//                                 type="video/mp4"
//                             />
//                         </video>

//                         <div
//                             style={{
//                                 position: 'absolute',
//                                 left: 0,
//                                 right: 0,
//                                 bottom: 0,
//                                 height: '120px',
//                                 pointerEvents: 'none',
//                                 background:
//                                     'linear-gradient(to top, rgba(0,0,0,.75), transparent)'
//                             }}
//                         />
//                     </div>
//                 </div>



//             )} */}

//             {activeFullscreenVideo && (
//                 <div onClick={() => setActiveFullscreenVideo(null)} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', }} >

//                     <button onClick={() => setActiveFullscreenVideo(null)}
//                         style={{ position: 'absolute', top: '30px', right: '40px', background: 'none', border: 'none', color: '#FFF', fontSize: '2.5rem', cursor: 'pointer', opacity: 0.8 }}>
//                         ✕
//                     </button>
//                     <video autoPlay controls playsInline onClick={(e) => e.stopPropagation()}
//                         style={{ width: '90vw', maxHeight: '85vh', borderRadius: '16px', boxShadow: '0 30px 70px rgba(0,0,0,0.8)', background: '#000' }}>
//                         <source src={activeFullscreenVideo} type="video/mp4" />
//                     </video>

//                 </div>)}
//         </div>
//     );
// };

// export default VideoShowcase;

import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import bedroom1video from '../Assets/slider/bedroom1video.mp4';
import baseinvideo from '../Assets/slider/Basinvideo.mp4';
import shoesrackvideo from '../Assets/slider/Entrancevideo.mp4';
import kitchen from '../Assets/slider/Kitchenvideo.mp4';
import kitchennew from '../Assets/slider/Kitchenvideonew.mp4';

import lrvideo1 from '../Assets/slider/sanketsirLivingroomvideo.mp4';
import lrvideo2 from '../Assets/slider/livingroomvideo.mp4';

import baseroomvideo2 from '../Assets/slider/Bedroomvideo.mp4';

const VideoShowcase = () => {
    const [activeVideoId, setActiveVideoId] = useState(1);
    const [activeFullscreenVideo, setActiveFullscreenVideo] = useState(null);
    const videoRefs = useRef({});
    const scrollerRef = useRef(null);

    // Dynamic Tracking Reference Hooks for Speed Dampening Logic
    const targetScrollLeft = useRef(0);
    const currentScrollLeft = useRef(0);
    const animationFrameId = useRef(null);

    // 8 Premium Video Case Studies Dataset
    const videoPlaylist = [
        { id: 1, num: '01',loc:'Bhugaon,Pune', title: 'The Linen Kitchen Vault', category: 'Kitchen Architecture', duration: '0:31', src: kitchen, desc: 'Bespoke modular framework engineering with warm overhead pastel luminance profiles and hidden channel integration paths.', sqft: '80 SQFT' },
        { id: 2, num: '02',loc:'Bhugaon,Pune', title: 'Alabaster Bedroom Suite', category: 'Luxury Residential', duration: '0:49', src: bedroom1video, desc: 'Symmetrical space planning intended to optimize rest parameters, using organic linen layers and recessed wall downlights.', sqft: '100 SQFT' },
        { id: 3, num: '03',loc:'Bhugaon,Pune', title: 'Sleek Modern Washbasin Vanity', category: 'Bespoke Washbasin Alcove', duration: '0:8', src: baseinvideo, desc: 'This bespoke washbasin alcove pairs rich wooden cabinetry with a bold black vessel sink. Framed by fluted wall tiles and illuminated by sculptural ribbon sconces, the tailored layout creates a striking, luxurious focal point.', sqft: '16 SQFT' },
        { id: 4, num: '04',loc:'Bhugaon,Pune', title: 'Elegant Foyer Entryway Layout', category: 'Foyer Layout', duration: '0:20', src: shoesrackvideo, desc: 'A warm and sophisticated residential entry featuring a custom wooden shoe rack with patterned arch inserts and an integrated planter cutout. Above, a textured, backlit circular nameplate shelf adds a personalized artistic statement to the welcoming space.', sqft: '92 SQFT' },
        { id: 5, num: '05',loc:'Bhugaon,Pune', title: 'Japandi Living Room Layout', category: 'Luxury Residential', duration: '0:57', src: lrvideo1, desc: 'This serene residential living room blends Japandi design with functional luxury, featuring mid-century inspired wooden furniture with cane detailing. A large backlit circular botanical artwork anchors the fluted wall panelling, creating a calm and inviting atmosphere', sqft: '203 SQFT' },
        { id: 6, num: '06',loc:'Bhugaon,Pune', title: 'Bespoke Platform Bedroom Design', category: 'Bespoke Item Art', duration: '0:51', src: baseroomvideo2, desc: 'A sophisticated primary bedroom maximizing space with an elevated wooden platform bed and integrated floor-to-ceiling arched wardrobes. The textured dark stone accent wall, accented by hidden warm LED strip lighting and a plush channel-tufted headboard, creates an intimate and luxurious sanctuary.', sqft: '100 SQFT' },
        { id: 7, num: '07',loc:'Bhugaon,Pune', title: 'Traditional Wooden Seating Lounge', category: 'Luxury Residential', duration: '0:42', src: lrvideo2, desc: 'A refined formal living setup featuring finely carved solid wood sofa sets paired with traditional Indian block-printed upholstery. Anchored by an intricate patterned area rug and flanked by sheer floor-to-ceiling curtains, this space blends classic heritage charm with modern layout fluidity.', sqft: '169 SQFT' },
        { id: 8, num: '08',loc:'Bhugaon,Pune', title: 'Contemporary Modular Kitchen Design', category: 'Kitchen Architecture', duration: '0:38', src: kitchennew, desc: 'A bright, space-efficient L-shaped kitchen featuring sleek handleless high-gloss white cabinetry paired with durable black granite countertops. A striking blue and white Moroccan-patterned tile backsplash serves as a vibrant visual anchor, beautifully illuminated by integrated under-cabinet LED profile lighting.', sqft: '60 SQFT', }
    ];

    const currentProject = videoPlaylist.find(v => v.id === activeVideoId) || videoPlaylist[0];

    const theme = {
        background: '#F8F6F2',
        surface: '#FFFFFF',
        accent: '#D4AF37',
        textMain: '#2C302E',
        textMuted: '#7A827E',
        border: 'rgba(44, 48, 46, 0.08)'
    };

    // ==================== LERP MATH RENDERING ENGINE ====================
    useEffect(() => {
        const smoothRenderLoop = () => {
            if (!scrollerRef.current) return;

            // 0.04 is your Speed Control. Lower = Slower/Smoother, Higher = Snappier
            const speedFactor = 0.04;

            // Linear Interpolation: distance remaining * speed factor
            const distance = targetScrollLeft.current - currentScrollLeft.current;
            currentScrollLeft.current += distance * speedFactor;

            // Push pixel offset update directly to the DOM
            scrollerRef.current.scrollLeft = currentScrollLeft.current;

            // Loop animation continuously via window rendering tick pipelines
            animationFrameId.current = requestAnimationFrame(smoothRenderLoop);
        };

        animationFrameId.current = requestAnimationFrame(smoothRenderLoop);

        return () => {
            if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow =
            activeFullscreenVideo ? 'hidden' : 'auto';

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [activeFullscreenVideo]);

    // ==================== CONTROLLED MOUSE COORDINATE MAPPING ====================
    const handleCursorTracking = (e) => {
        if (!scrollerRef.current || window.innerWidth <= 991) return;
        const scroller = scrollerRef.current;
        const rect = scroller.getBoundingClientRect();

        // Find cursor coordinate relative to container width
        const mouseX = e.clientX - rect.left;

        // Create buffer dead-zones at the edges (10% left/right padding) to prevent violent snapping
        let positionRatio = (mouseX - rect.width * 0.1) / (rect.width * 0.8);
        if (positionRatio < 0) positionRatio = 0;
        if (positionRatio > 1) positionRatio = 1;

        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

        // Update the target vector reference hook instead of forcefully snapping the element
        targetScrollLeft.current = positionRatio * maxScrollLeft;
    };

    const handleScrollPhysics = () => {
        if (!scrollerRef.current) return;
        const scroller = scrollerRef.current;
        const cardElement = scroller.firstChild;
        if (!cardElement) return;

        const cardWidth = cardElement.offsetWidth + 25;
        const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 3);
        const index = Math.floor(scrollPosition / cardWidth);

        if (videoPlaylist[index] && videoPlaylist[index].id !== activeVideoId) {
            if (videoRefs.current[activeVideoId]) videoRefs.current[activeVideoId].pause();
            setActiveVideoId(videoPlaylist[index].id);
            if (videoRefs.current[videoPlaylist[index].id]) {
                videoRefs.current[videoPlaylist[index].id].play().catch(() => { });
            }
        }
    };

    const handleMouseEnter = (id) => {
        setActiveVideoId(id);
        if (videoRefs.current[id]) {
            videoRefs.current[id].play().catch(() => { });
        }
    };

    const handleMouseLeave = (id) => {
        if (videoRefs.current[id]) {
            videoRefs.current[id].pause();
            videoRefs.current[id].currentTime = 0;
        }
    };

    const inlineCinemaStyles = `
        /* Dynamic import of the luxury Roman serif font */
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

        @keyframes revealUp {
            from { opacity: 0; transform: translateY(50px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .team-animate-entry { 
            animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
        }

        @keyframes lineExtend { from { width: 0%; } to { width: 100%; } }
        .animate-gold-line { animation: lineExtend 0.5s ease forwards; }

        @keyframes textReveal { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
        .animate-text-reveal { animation: textReveal 0.4s ease-out forwards; }

        .custom-scroll-deck::-webkit-scrollbar { display: none; }
        .custom-scroll-deck { -ms-overflow-style: none; scrollbar-width: none; }

        /* ==================== SCREEN RESPONSIVENESS ==================== */
        @media (max-width: 991px) {
            .cinema-asymmetric-split { flex-direction: column-reverse !important; gap: 30px !important; }
            .cinema-left-sticky-deck { position: relative !important; top: 0 !important; height: auto !important; min-width: 100% !important; padding-right: 0 !important; border-right: none !important; }
            .cinema-film-strip-card { min-width: 80vw !important; height: 360px !important; }
            .showcase-screen-wrapper { padding: 30px 20px !important; }
            
            .team-title-main {
                font-size: 2.2rem !important;
                letter-spacing: 4px !important;
            }
        }
        
        @keyframes fadeIn {
            from { opacity: 0; backdrop-filter: blur(0px); }
            to { opacity: 1; backdrop-filter: blur(16px); }
        }

        @keyframes scaleIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
        }
    `;

    return (
        <div className="showcase-screen-wrapper" style={{
            background: theme.background,
            minHeight: '100vh',
            color: theme.textMain,
            padding: '40px 60px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            boxSizing: 'border-box',
            overflowX: 'hidden'
        }}>
            <style>{inlineCinemaStyles}</style>

            {/* ==================== REFINED ALIGNED HEADER SECTION ==================== */}
            <div className="team-animate-entry" style={{
                textAlign: 'center',
                marginBottom: '90px',
                padding: '0 20px'
            }}>
                <span style={{
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '4px',
                    color: theme.accent,
                    display: 'block',
                    marginBottom: '12px'
                }}>
                    Motion Architecture
                </span>
                <h2 className="team-title-main" style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: 'calc(0.3rem + 1.5vw)',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    letterSpacing: '6px',
                    color: theme.textMain,
                    margin: 0
                }}>
                    Cinematic Reels
                </h2>
                <div style={{
                    width: '60px',
                    height: '1px',
                    background: theme.accent,
                    margin: '24px auto 0 auto'
                }} />
            </div>

            {/* ==================== CORE ASYMMETRIC CONTROLLER DECK ==================== */}
            <div className="cinema-asymmetric-split" style={{ display: 'flex', gap: '60px', marginTop: '20px', alignItems: 'stretch' }}>

                {/* LEFT AREA: METADATA DESCRIPTION */}
                <div className="cinema-left-sticky-deck" style={{
                    flex: '0.8',
                    minWidth: '320px',
                    position: 'sticky',
                    top: '40px',
                    height: 'calc(100vh - 200px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    paddingRight: '40px',
                    borderRight: `1px solid ${theme.border}`,
                    boxSizing: 'border-box'
                }}>
                    <div>
                        <div key={activeVideoId} className="animate-text-reveal" style={{ marginTop: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', color: theme.accent, fontWeight: '700', fontSize: '0.9rem', fontFamily: 'monospace' }}>
                                <span>{currentProject.num}</span>
                                <div style={{ height: '1px', background: theme.accent, width: '30px' }} />
                                <span style={{ textTransform: 'uppercase', letterSpacing: '1.5px' }}>{currentProject.category}</span>
                            </div>

                            <h2 style={{ fontSize: '2rem', fontWeight: '400', margin: '15px 0', color: theme.textMain, letterSpacing: '0.5px', fontFamily: "'Lora', serif" }}>{currentProject.title}</h2>

                            <p style={{ fontSize: '1rem', lineHeight: '1.7', color: theme.textMuted, maxWidth: '440px', margin: '0 0 30px 0', fontFamily: "'Cormorant Garamond', serif", }}>{currentProject.desc}</p>
                        </div>
                    </div>

                    <div key={`metrics-${activeVideoId}`} className="animate-text-reveal" style={{ paddingBottom: '20px' }}>
                        <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '15px', width: 'fit-content' }}>
                             <p style={{ color: '#D4AF37', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.9rem', margin: '0 0 30px 0' }}>
                                  location — {currentProject.loc}
                            </p>
                            <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: theme.textMuted, letterSpacing: '1px', display: 'block' }}>Project Dimensions</span>
                            <span style={{ fontSize: '1.3rem', fontWeight: '600', color: theme.textMain, marginTop: '4px', display: 'block', fontFamily: "'Cormorant Garamond', serif" }}>{currentProject.sqft}</span>
                        </div>
                    </div>
                </div>

                {/* RIGHT AREA: SMOOTH DAMPENED FILM REEL DECK */}
                <div
                    className="custom-scroll-deck"
                    ref={scrollerRef}
                    onMouseMove={handleCursorTracking}
                    onScroll={handleScrollPhysics}
                    style={{
                        flex: '1.6',
                        display: 'flex',
                        flexDirection: 'row',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        gap: '25px',
                        padding: '10px 5px 25px 5px',
                        alignItems: 'center'
                    }}
                >
                    {videoPlaylist.map((video) => {
                        const isActive = activeVideoId === video.id;

                        return (
                            <div
                                key={video.id}
                                className="cinema-film-strip-card"
                                onMouseEnter={() => handleMouseEnter(video.id)}
                                onMouseLeave={() => handleMouseLeave(video.id)}
                                onClick={() => setActiveFullscreenVideo(video.src)}
                                style={{
                                    position: 'relative',
                                    height: '460px',
                                    minWidth: '400px',
                                    borderRadius: '24px',
                                    overflow: 'hidden',
                                    background: '#1A1C1B',
                                    border: `1px solid ${isActive ? theme.accent : theme.border}`,
                                    cursor: 'pointer',
                                    boxShadow: isActive ? '0 20px 45px rgba(212, 175, 55, 0.08)' : '0 4px 20px rgba(0,0,0,0.01)',
                                    transform: isActive ? 'translateY(-6px)' : 'translateY(0)',
                                    transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
                                    scrollSnapAlign: 'center',
                                    flexShrink: 0
                                }}
                            >
                                <video
                                    ref={(el) => (videoRefs.current[video.id] = el)}
                                    loop
                                    muted
                                    playsInline
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        opacity: isActive ? 1 : 0.55,
                                        filter: isActive ? 'none' : 'grayscale(20%) brightness(85%)',
                                        transition: 'all 0.5s ease'
                                    }}
                                >
                                    <source src={video.src} type="video/mp4" />
                                </video>

                                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 100%)', zIndex: 2, pointerEvents: 'none' }} />

                                {isActive && (
                                    <div className="animate-gold-line" style={{ position: 'absolute', bottom: 0, left: 0, height: '4px', background: theme.accent, zIndex: 4 }} />
                                )}

                                <div style={{ position: 'absolute', bottom: '25px', left: '25px', zIndex: 3, color: '#FFF' }}>
                                    <span style={{ fontSize: '0.8rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}>{video.category}</span>
                                    <h4 style={{ margin: '4px 0 0 0', fontWeight: '400', fontSize: '1.1rem', letterSpacing: '0.5px' }}>{video.title}</h4>
                                </div>

                                <div style={{ position: 'absolute', bottom: '25px', right: '25px', zIndex: 3, background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(6px)', color: '#FFF', padding: '5px 12px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '600' }}>
                                    {video.duration} <span style={{ marginLeft: '6px', color: theme.accent }}>▶</span>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>

            {/* ==================== WHITE SMOKY GLASSMORPHISM LIGHTBOX MODAL ==================== */}
            {activeFullscreenVideo && (
                <div
                    onClick={() => setActiveFullscreenVideo(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 200,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: 'rgba(248, 246, 242, 0.78)',
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                        animation: 'fadeIn 0.4s ease-out'
                    }}
                >
                    <button
                        onClick={() => setActiveFullscreenVideo(null)}
                        style={{
                            position: 'absolute',
                            top: '30px',
                            right: '40px',
                            background: '#FFFFFF',
                            border: '1px solid rgba(44, 48, 46, 0.1)',
                            color: theme.textMain,
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            fontSize: '1.2rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease',
                            zIndex: 201
                        }}
                    >
                        ✕
                    </button>

                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: '90vw',
                            maxWidth: '1200px',
                            maxHeight: '85vh',
                            borderRadius: '24px',
                            overflow: 'hidden',
                            background: '#FDFDFB',
                            boxShadow: '0 30px 80px rgba(44, 48, 46, 0.12), 0 10px 30px rgba(0,0,0,0.02)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid rgba(255,255,255,0.8)',
                            animation: 'scaleIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
                        }}
                    >
                        <video
                            autoPlay
                            controls
                            playsInline
                            style={{
                                width: '100%',
                                maxHeight: '85vh',
                                display: 'block',
                                objectFit: 'contain',
                                background: 'transparent'
                            }}
                        >
                            <source src={activeFullscreenVideo} type="video/mp4" />
                        </video>
                    </div>

                </div>
            )}
        </div>
    );
};

export default VideoShowcase;